/// <reference types="@angular/localize" />

import { enableProdMode, ErrorHandler } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser'; // changed
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

class BootstrapErrorHandler implements ErrorHandler {
  handleError(error: Error): void {
    this.logError(error);
  }

  private logError(error: Error): void {
    console.error('An error occurred');
    if (!environment.production) {
      console.log('Error message:', error.message);
      console.log('Error stack:', error.stack);
      console.log('Error name:', error.name);
    }
  }
}

platformBrowser().bootstrapModule(AppModule)
  .catch(err => new BootstrapErrorHandler().handleError(err));